import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";
import { getSignedUrl } from "ServerAPI/serverAPI";

const ImageRenderer = ({ activeContent, fileName }) => {
  const { courseId, sectionId } = useParams();
  const [cookies] = useCookies();
  const [imageUrl, setImageUrl] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

  const getImageUrl = async () => {
    setImageLoading(true);
    const payload = {
      courseId: courseId,
      sectionId: sectionId,
      fileName: fileName,
      method: "GET",
      userId: cookies?.userId,
    };
    try {
      const response = await getSignedUrl(payload);
      const generatedUrl = response.data.preSignedUrl;
      setImageUrl(response?.data?.preSignedUrl);
      setImageLoading(false);
    } catch (error) {
      console.error("Error fetching the video URL:", error);
    }
  };
  useEffect(() => {
    getImageUrl();
  }, [courseId, sectionId, fileName]);
  return (
    <section className="mt-6 course-container">
      <Container fluid>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <div className="content">
              <div>
                {imageLoading ? (
                  <div className="d-flex justify-content-center align-items-center w-100 h-100 course-container">
                    <Spinner />
                  </div>
                ) : (
                  <div
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      height: "80vh",
                    }}
                  >
                    <img
                      src={imageUrl}
                      alt="image content"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ImageRenderer;
